import http from "../../http"
import { showError } from "../../utils/snackbar"

const app = sessionStorage.getItem("app")

export const fetchPageData = async (apiBody) => {
    let response
    let data
    switch (app) {
        default:
            response = await http("POST", "api/v1/data", {
                apiData: apiBody,
            }).catch((er) => {
                showError(er)
            })
            data = response
    }

    return data
}
